module.exports = __webpack_public_path__ + "img/P150T_weapon_20.dfaa095b.png";